import { showSnackbar } from 'utils/snack_bar/store/action';
import { actionTypes, CreatePackageInput, PackageProps, PackagesPaylodProps, UpdatePackageInput } from './actionType';
import { CREATE_PACKAGE, DELETE_PACKAGE, UPDATE_PACKAGE } from '../graphql/mutation';
import { FETCH_PACKAGES } from '../graphql/query';
import { executeMutation, executeQuery } from 'utils/services/apiServices';

// fetch package
export const fetchPackagesRequest = () => ({
    type: actionTypes.FETCH_PACKAGES_REQUEST
});

export const fetchPackagesSuccess = (payload: PackagesPaylodProps[]) => ({
    type: actionTypes.FETCH_PACKAGES_SUCCESS,
    payload
});

export const fetchPackagesFail = (payload: string) => ({
    type: actionTypes.FETCH_PACKAGES_FAIL,
    payload
});

export const fetchPackages = () => {
    return async (dispatch: any) => {
        try {
            await dispatch(fetchPackagesRequest());
            const response = await executeQuery(FETCH_PACKAGES);
            const jsonData = response.data?.fetchAllPackages;
            if (jsonData?.error === null) {
                dispatch(fetchPackagesSuccess(jsonData?.data.packages));
            } else {
                dispatch(fetchPackagesFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchPackagesFail('Failed to fetch  package(s)'));
        }
    };
};

//create package
export const createPackageSuccess = (payload: PackagesPaylodProps) => ({
    type: actionTypes.CREATE_PACKAGE_SUCCESS,
    payload
});
export const createPackageFail = (payload: string) => ({
    type: actionTypes.CREATE_PACKAGE_FAIL,
    payload
});

export const createPackage = (createPackageInput: CreatePackageInput) => {
    return async (dispatch: any) => {
        try {
            const response = await executeMutation(CREATE_PACKAGE,createPackageInput);
            const jsonData = response.data?.createPackages;
            if (jsonData?.error === null) {
                dispatch(createPackageSuccess(jsonData?.data.package));
                dispatch(showSnackbar('Success! Package created.'));
            } else {
                dispatch(createPackageFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createPackageFail('Something went wrong, Try again later'))
        }
    };
};

//update package
export const updatePackagesSuccess = (payload: PackageProps) => ({
    type: actionTypes.UPDATE_PACKAGE_SUCCESS,
    payload
});
export const updatePackagesFail = (payload: string) => ({
    type: actionTypes.UPDATE_PACKAGE_FAIL,
    payload
});

export const updatePackage = (input: UpdatePackageInput) => {
    return async (dispatch: any) => {
        try {
            const response = await executeMutation(UPDATE_PACKAGE,input);
            const jsonData = response.data?.updatePackage;
            if (jsonData?.error === null) {
                dispatch(updatePackagesSuccess(jsonData?.data.package));
                dispatch(showSnackbar('Success! Package created.'));
            } else {
                dispatch(updatePackagesFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updatePackagesFail('Something went wrong, Try again later'))
        }
    };
};

//delete package
export const deletePackagesSuccess = (payload: string) => ({
    type: actionTypes.DELETE_PACKAGE_SUCCESS,
    payload
});
export const deletePackagesFail = (payload: string) => ({
    type: actionTypes.DELETE_PACKAGE_FAIL,
    payload
});

export const deletePackage = (package_id:string) => {
    return async (dispatch: any) => {
        try {
            const input = {
                package_id:package_id,
            }
            const response = await executeMutation(DELETE_PACKAGE,input);
            const jsonData = response.data?.deletePackage;
            if (jsonData?.error === null) {
                dispatch(deletePackagesSuccess(package_id));
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            } else {
                dispatch(deletePackagesFail(jsonData?.error.message));
                dispatch(showSnackbar('Fail to deleted.'));
            }
        } catch (error: any) {
            dispatch(deletePackagesFail('Something went wrong, Try again later'));
        }
    };
};


//RESET
export const ResetPackage = () => ({
  type: actionTypes.RESET_PACKAGE
});

export const resetPackage = () => {
  return async (dispatch: any) => {
    dispatch(ResetPackage());
  };
};